import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-empty-state',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslatePipe],
  templateUrl: './empty-state.component.html',
  styleUrl: './empty-state.component.css'
})
export class EmptyStateComponent {
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() icon: 'empty' | 'search' | 'folder' = 'empty';
  @Input() actionLabel?: string;
  @Input() actionRouterLink?: any[] | string;
  @Input() compact: boolean = false;

  @Output() action = new EventEmitter<void>();

  onAction(): void {
    this.action.emit();
  }
}
